import { Drawer, DrawerContent, DrawerOverlay, DrawerPortal } from "../Drawer"
import type { NovaSession } from "@/types"
import { graphql } from "@/gql"
import { ProjectSideDrawerContent } from "./ProjectSideDrawerContent"

interface ProjectSideDrawerProps {
  open: boolean
  serverSession: NovaSession | null
  projectId: string
  onClose?: (open: boolean) => void
  onBack?: () => void
}

graphql(`
  query GetSimpleProject($projectId: ID!) {
    creativeWorkPortfolioProject(id: $projectId) {
      id
      title
      description
      ...ApplicationRolePreview
      files {
        edges {
          node {
            id
            __typename
            metadata {
              video
            }
            file
            ...Video
            ...ProjectMedia
          }
        }
      }
    }
  }
`)

export const ProjectSideDrawer = ({ onBack, projectId, serverSession, open, onClose }: ProjectSideDrawerProps) => {
  return (
    <Drawer onOpenChange={onClose} open={open}>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerContent className="flex w-full !max-w-[100%] flex-col !gap-0 overflow-y-hidden border-none !px-0 !pb-0 !pt-0 sm:!px-10 md:w-[480px] lg:w-[600px]">
          <ProjectSideDrawerContent projectId={projectId} onBack={onBack} onClose={onClose} />
        </DrawerContent>
      </DrawerPortal>
    </Drawer>
  )
}
